import React from "react";
import "./BannerImg.css";
import { HiArrowNarrowRight } from "react-icons/hi";

const BannerImg = () => {
  return (
    <div className="container mx-auto">
      <div className="BannerImg-head">
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5abab99cfb3b8e52116fc_sodexo%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/6321874555025f7cf7a5242c_uni%20of%20bristol%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5abade224a726cba4459e_man%20uni%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5abacb0058018d0d576ab_Neat%20burger%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5abab9dab04e108bfd459_Wahaca%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5abac8d9a356c841a304f_Quorn%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c6c315496836ac4a42ab87_Levy%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c6cf197bed4e394c2f8e6d_Mowgli%20logo.svg"
            alt=""
          />
        </div>
        <div className="subImgBanner">
          <img
            src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/62c5ababc246417c02213d1e_Ready%20burger%20logo.svg"
            alt=""
          />
        </div>
      </div>

      <div className="bannerTitle">
        <h1>With Klimato you can...</h1>
      </div>

      {/* another section start */}

      <div className="Banner-cart">
        <div className="subBannerCart">
          <img
            src="https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/512x512/print_calculator.png"
            alt=""
          />
          <h1>Calculate</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ea odio
            iure amet deserunt earum?
          </p>
        </div>
        <div className="subBannerCart">
          <img
            src="https://img.lovepik.com/free-png/20210926/lovepik-man-communication-icon-free-vector-illustration-png-image_401495259_wh1200.png"
            alt=""
          />
          <h1>Communication</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ea odio
            iure amet deserunt earum?
          </p>
        </div>
        <div className="subBannerCart">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSUvaFtvGzCXKY3oA6AnUJsO3krEaaK9pdxzrHALr2BK_ZYi9ulvw-Y9oEZcVUf_Au2I5g&usqp=CAU"
            alt=""
          />
          <h1>Report</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ea odio
            iure amet deserunt earum?
          </p>
        </div>
        <div className="subBannerCart">
          <img
            src="https://cdn-icons-png.flaticon.com/512/1024/1024192.png"
            alt=""
          />
          <h1>Offest</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ea odio
            iure amet deserunt earum?
          </p>
        </div>
      </div>

      <div>
        <div className="Section">
          <div className="Content">
            <img src={require("../../../assets/194538_standard.jpeg")} alt="" />
          </div>
          <div className="Content">
            <h1>The Challenge</h1>
            <p>
              The global food system accounts for 28% of global greenhouse gas
              emissions. This number could however be cut in half by changing
              our diets to eat more climate friendly food.
            </p>
            <button className="Button">
              Learn More{" "}
              <span>
                <HiArrowNarrowRight></HiArrowNarrowRight>
              </span>
            </button>
          </div>

          <div className="Content">
            <h1>The solution</h1>
            <p>
              The global food system accounts for 28% of global greenhouse gas
              emissions. This number could however be cut in half by changing
              our diets to eat more climate friendly food.
            </p>
            <button className="Button">
              Learn More{" "}
              <span>
                <HiArrowNarrowRight></HiArrowNarrowRight>
              </span>
            </button>
          </div>
          <div className="Content">
            <img
              src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/614498e6cd935cf2bbf5506f_solution.png"
              alt=""
            />
          </div>

          <div className="Content">
            <img
              src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/6153290e64f57b022969f8db_backed%20by%20image-p-500.png"
              alt=""
            />
          </div>
          <div className="Content">
            <h1>Backed by professionals</h1>
            <p>
              Klimato parters with industry professionals to make sure our data
              research and methodologies are as accurate and up to date as
              possible.
            </p>
            <button className="Button ">
              Learn More{" "}
              <span>
                <HiArrowNarrowRight></HiArrowNarrowRight>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div>
        <div className="Extra-section">
          <div className="Content">
            <h1>Are you ready to take climate action?</h1>

            <div className="flex Button-group">
              <button className="button">Get Started</button>
              <button className="btn">Learn More</button>
            </div>
          </div>
          <div className="Content">
            <img
              src="https://uploads-ssl.webflow.com/609a6d7a4139b750702098a1/6189221fcd7581e890059b57_Startup%20vibe.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerImg;
